var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Plus2 = function Plus2(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 31 31' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'upload-logo'
      ),
      React.createElement(
        'g',
        { fill: 'currentColor', fillRule: 'evenodd' },
        React.createElement('path', { d: 'M.5 16H31v-1H0v1z' }),
        React.createElement('path', { d: 'M15 .5V31h1V0h-1z' })
      )
    )
  );
};
/*eslint-enable */

export default Plus2;
//# sourceMappingURL=Plus2.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Plus2.js